export default {
	actions: [
		{
			name: 'submit',
			title: 'Submit',
		},
		{
			name: 'saveState',
			title: 'Save in state',
		},
		{
			name: 'event',
			title: 'Event',
		},
		{
			name: 'custom',
			title: 'Custom',
		},
		{
			name: 'reset',
			title: 'Reset',
		},
		{
			name: 'delete',
			title: 'Delete',
		},
		{
			name: 'url',
			title: 'POST to URL',
		},
		{
			name: 'oauth',
			title: 'OAuth',
		},
	],
	themes: [
		{
			name: 'default',
			title: 'Default',
		},
		{
			name: 'primary',
			title: 'Primary',
		},
		{
			name: 'info',
			title: 'Info',
		},
		{
			name: 'success',
			title: 'Success',
		},
		{
			name: 'danger',
			title: 'Danger',
		},
		{
			name: 'warning',
			title: 'Warning',
		},
	],
	sizes: [
		{
			name: 'xs',
			title: 'Extra Small',
		},
		{
			name: 'sm',
			title: 'Small',
		},
		{
			name: 'md',
			title: 'Medium',
		},
		{
			name: 'lg',
			title: 'Large',
		},
	],
};
